export default [
    {
        name: "select_element",
        description:
            "Find/select an element based on their element_id. You can deduce the id based on extra information provided in the list of layers in the template. If you can't deduce, use the currently selected layer.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element that is going to be selected.",
                },
            },
            required: ["element_id"],
        },
    },
    {
        name: "change_element_product_id",
        description:
            "Edit product IDs, GTIN, or ASIN of an element based on their element_id. You can deduce the id based on extra information provided in the list of layers in the template. If you can't deduce, use the currently selected layer.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element that is going to be selected. Optional - if not provided, will use the currently selected element.",
                },
                new_product_id: {
                    type: "string",
                    description: "The new ID, GTIN or ASIN code.",
                },
            },
            required: ["new_product_id"],
        },
    },
    {
        name: "replace_element_image",
        description:
            "Replace the image of an element based on their element_id. You can deduce the id based on extra information provided in the list of layers in the template. If you can't deduce, use the currently selected layer.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element that is going to be selected. Optional - if not provided, will use the currently selected element.",
                },
                description_of_the_new_image: {
                    type: "string",
                    description: "A description of the new image that will be generated with AI, and replace the old image.",
                },
            },
            required: ["description_of_the_new_image"],
        },
    },
    {
        name: "edit_element_image",
        description:
            "Edit the content or appearance of an image element. This function should be used when the user wants to modify the actual image content (like removing text from an image, changing colors, adding/removing elements, etc.) rather than editing text elements. If the user wants to edit text that exists as a separate text element, use edit_element_text instead. You can deduce the id based on extra information provided in the list of layers in the template. If you can't deduce, use the currently selected layer.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the image element that is going to be edited. Optional - if not provided, will use the currently selected element.",
                },
                changes_to_the_image: {
                    type: "string",
                    description: "A description of the changes that will be made to the image content (e.g., 'remove the text NO ARTIFICIAL FLAVORS', 'make the background white', 'remove the person from the image').",
                },
            },
            required: ["changes_to_the_image"],
        },
    },
    {
        name: "edit_element_text",
        description:
            "Edit the text of an element based on their element_id. You can deduce the id based on extra information provided in the list of layers in the template. If you can't deduce, use the currently selected layer.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element that is going to be selected. Optional - if not provided, will use the currently selected element.",
                },
                new_text: {
                    type: "string",
                    description: "New text of the element.",
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the new text to all templates. It defaults to false unless requested by the user.",
                }
            },
            required: ["new_text", "apply_to_all"],
        },
    },
    {
        name: "edit_element_color",
        description:
            "Edit the color of an element based on their element_id. You can deduce the id based on extra information provided in the list of layers in the template. If you can't deduce, use the currently selected layer.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element that is going to be edited. Optional - if not provided, will use the currently selected element.",
                },
                new_color: {
                    type: "string",
                    description: "New color of the element in hex format.",
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the new color to all templates. It defaults to false unless requested by the user.",
                }
            },
            required: ["new_color", "apply_to_all"],
        },
    },
    {
        name: "edit_element_font_size",
        description:
            "Edit the font size of an element based on their element_id. You can deduce the id based on extra information provided in the list of layers in the template. If you can't deduce, use the currently selected layer.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element that is going to be edited. Optional - if not provided, will use the currently selected element.",
                },
                new_font_size: {
                    type: "string",
                    description: "New font size of the element.",
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the new font size to all templates. It defaults to false unless requested by the user.",
                }
            },
            required: ["new_font_size", "apply_to_all"],
        },
    },
    {
        name: "edit_element_font_family",
        description:
            "Edit the font family of an element based on their element_id. You can deduce the id based on extra information provided in the list of layers in the template If you can't deduce, use the currently selected layer. Wathever font the user specifies should be accepted.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element that is going to be edited. Optional - if not provided, will use the currently selected element.",
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the new font family to all templates. It defaults to false unless requested by the user.",
                }
            },
            required: ["apply_to_all"],
        },
    },
    {
        name: "edit_project_name",
        description: "Edit the project name of the template.",
        parameters: {
            type: "object",
            properties: {
                new_project_name: {
                    type: "string",
                    description: "New project name of the template.",
                },
            },
            required: ["new_project_name"],
        },
    },
    {
        name: "generate_proof_link",
        description: "Generate a proof link for the current project to share with others.",
    },
    {
        name: "check_product_id",
        description: "Use this function only when the user wants to verify if one or multiple product IDs, GTINs, or ASINs exist in the database. It should not be used as part of replacement or image editing flows.",
        parameters: {
            type: "object",
            properties: {
                product_id: {
                    type: "string",
                    description: "One or more product IDs, GTINs, or ASINs to check. For multiple IDs, separate them with spaces.",
                },
            },
            required: ["product_id"],
        }
    },
    {
        name: "publish_to_platform",
        description: "Open the publish dialog and select the specified platform",
        parameters: {
            type: "object",
            properties: {
                platform_type: {
                    type: "string",
                    enum: ['bynder', 'salsify', 'walmart'],
                    description: "Type of platform to publish to (Bynder, Salsify, or Walmart)"
                }
            },
            required: ['platform_type']
        },
        function: function(args) {
            const platformType = args.platform_type?.toLowerCase();
            if (!['bynder', 'salsify', 'walmart'].includes(platformType)) {
                return { error: `Unsupported platform type: ${platformType}` };
            }
            return { platform_type: platformType };
        }
    },
    {
        name: "move_object",
        description: "Move any object (image, text, or shape) in one of the four directions (up, down, left, right). ONLY use this for relative movements when the user explicitly says directional terms like 'move it left', 'move up', 'shift down', etc. DO NOT use this function when the user mentions 'x' or 'y' with numbers (like 'set x to 100' or 'y=200') - those ALWAYS refer to absolute coordinates and should use position_object instead. This function is specifically for relative directional movements, not setting exact coordinates. If no element_id is specified, the currently selected element will be used.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description: "Id of the element that is going to be moved. Optional - if not provided, will use the currently selected element.",
                },
                direction: {
                    type: "string",
                    enum: ["up", "down", "left", "right"],
                    description: "Direction to move the element."
                },
                distance: {
                    type: "number",
                    description: "Distance to move the element in pixels. Default is 10 if not specified.",
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the movement to all templates. Defaults to false unless requested by the user. Only applies to text and shape elements, not images.",
                }
            },
            required: ["direction"],
        },
    },
    {
        name: "rotate_image",
        description: "Rotate an image element by a specified angle. Works for product images and background theme images. If no element_id is specified, the currently selected element will be used.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description: "Id of the image element that is going to be rotated. Optional - if not provided, will use the currently selected element.",
                },
                angle: {
                    type: "number",
                    description: "Angle in degrees to rotate the image. Use 90 for 90 degrees clockwise, -90 for 90 degrees counterclockwise, etc."
                }
            },
            required: ["angle"]
        }
    },
    {
        name: "remove_image_background",
        description: "Remove the background from an image element. Works for product images and background theme images. If no element_id is specified, the currently selected element will be used.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description: "Id of the image element to remove background from. Optional - if not provided, will use the currently selected element.",
                },
                crop_to_image: {
                    type: "boolean",
                    description: "Whether to crop to the image after removing the background."
                }
            },
            required: []
        }
    },
    {
        name: "align_text",
        description: "Change the text alignment of a text element. If no element_id is specified, the currently selected element will be used.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description: "Id of the text element to align. Optional - if not provided, will use the currently selected element.",
                },
                alignment: {
                    type: "string",
                    enum: ["left", "center", "right"],
                    description: "Text alignment to apply."
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the alignment to all templates. Defaults to false unless requested by the user."
                }
            },
            required: ["alignment", "apply_to_all"]
        }
    },
    {
        name: "edit_shape_color",
        description:
            "Change the background/fill color of a shape element. If no element_id is specified, the system will try to find a shape based on the context of the user's message.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element that is going to be edited. Optional - if not provided, will attempt to find a shape by context.",
                },
                new_color: {
                    type: "string",
                    description: "New color of the element in hex format.",
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the new color to all templates. It defaults to false unless requested by the user.",
                }
            },
            required: ["new_color", "apply_to_all"],
        },
    },
    {
        name: "edit_shape_border",
        description:
            "Edit the border of a shape based on their element_id. If no element_id is specified, the system will try to find a shape based on the context of the user's message.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element that is going to be edited. Optional - if not provided, will attempt to find a shape by context.",
                },
                border_color: {
                    type: "string",
                    description: "New border color in hex format.",
                },
                border_width: {
                    type: "number",
                    description: "New border width/thickness in pixels.",
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the changes to all templates. It defaults to false unless requested by the user.",
                }
            },
            required: ["apply_to_all"],
        },
    },
    {
        name: "center_object",
        description:
            "Center the selected object in the canvas. If no element_id is specified, the currently selected element will be used.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element that is going to be centered. Optional - if not provided, will use the currently selected element.",
                },
                alignment: {
                    type: "string",
                    enum: ["both", "horizontal", "vertical"],
                    description: "How to center the object: horizontally, vertically, or both (center in canvas).",
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the centering to all templates. It defaults to false unless requested by the user.",
                }
            },
            required: ["alignment", "apply_to_all"],
        },
    },
    {
        name: "change_layer_order",
        description:
            "Change the order of a layer by bringing it to front, sending to back, etc. If no element_id is specified, the currently selected element will be used.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element whose order will be changed. Optional - if not provided, will use the currently selected element.",
                },
                position: {
                    type: "string",
                    enum: ["front", "back", "forward", "backward"],
                    description: "The new position for the layer: 'front' (bring to front), 'back' (send to back), 'forward' (bring forward), 'backward' (send backward).",
                }
            },
            required: ["position"],
        },
    },
    {
        name: "resize_element",
        description:
            "Resize a shape or image element. If no element_id is specified, the currently selected element will be used.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element to resize. Optional - if not provided, will use the currently selected element.",
                },
                scale: {
                    type: "number",
                    description: "Scale factor to apply to both width and height (e.g., 1.5 for 150%, 0.5 for 50%). Default scale amount is 0.1 (10%) if not specified or scale direction is used.",
                },
                scale_direction: {
                    type: "string",
                    enum: ["up", "down"],
                    description: "Direction to scale - 'up' increases size by 10%, 'down' decreases size by 10%. Alternative to specifying an exact scale factor.",
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the resize to all templates. Defaults to false unless requested by the user.",
                }
            },
            required: ["apply_to_all"],
        },
    },
    {
        name: "position_object",
        description:
            "Set the exact X and/or Y coordinates of an object in the canvas. ALWAYS use this function whenever a user refers to 'x' or 'y' without additional context - assume they are referring to position coordinates. This includes ANY command such as 'set x to 100', 'x=50', 'make x 200', 'change x to 75', 'x value of 150', 'y coordinate 300', etc. Whenever you see 'x' or 'y' mentioned with a number, use this function to set the position. In the context of this application, 'x' and 'y' ALWAYS refer to position coordinates unless explicitly stated otherwise. NEVER use move_object for these absolute coordinate requests. If no element_id is specified, the currently selected element will be used.",
        parameters: {
            type: "object",
            properties: {
                element_id: {
                    type: "string",
                    description:
                        "Id of the element to position. Optional - if not provided, will use the currently selected element.",
                },
                x: {
                    type: "number",
                    description: "The exact X coordinate to set for the object's position (horizontal position).",
                },
                y: {
                    type: "number",
                    description: "The exact Y coordinate to set for the object's position (vertical position).",
                },
                apply_to_all: {
                    type: "boolean",
                    description: "Apply the position to all templates. Defaults to false unless requested by the user. Only applies to text and shape elements, not images.",
                }
            },
            // At least one of x or y must be provided, apply_to_all is optional
            required: [],
        },
    },
    {
        name: "resize_banner",
        description:
            "Resize the entire banner to the specified width and height.",
        parameters: {
            type: "object",
            properties: {
                width: {
                    type: "number",
                    description: "The new width of the banner.",
                },
                height: {
                    type: "number",
                    description: "The new height of the banner.",
                }
            },
            required: ["width", "height"],
        },
    },
];
